import { gaTracking, getCurrentPageLocation } from "../../lib/ga";
import { mapInsuranceName } from "../../lib/insuranceMapping";

/**
 * Tracks filter click events when users apply filters
 * @param insurance - Selected insurance/event filter (försäkringshändelse), will be mapped to analytics name
 * @param subject - Selected subject filter (ämne)
 * @see /GAExamples/filter_click.js
 *
 * Note: At least one filter parameter should be provided
 */
export const filterClickTracker = (insurance?: string, subject?: string): void => {
  // Only track if at least one filter is set
  if (!insurance && !subject) {
    console.warn("filterClickTracker called without any filter values");
    return;
  }

  gaTracking({
    event: "filter_click",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      insurance: mapInsuranceName(insurance),
      subject,
    },
  });
};
